import React from 'react';
import { connect } from 'react-redux';
import { Label, Icon } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import clsx from 'clsx';
import findResult from '@/utils/resultsHelper';
import { states, updateStates } from '@/constants/lifecycle';
import WarningPopup from '@/components/WarningPopup';
import { userStatusContext } from '../helper';
import { showArchiveUser, toggleUserApproved } from '../actions';

const UserStatus = ({
  canApprove,
  canArchive,
  category,
  code,
  disabled,
  isCurrentUser,
  onToggleApproved,
  showArchive,
  user,
}) => {
  const intl = useIntl();
  if (!canApprove && !canArchive) { return null; }
  const context = userStatusContext(
    user,
    canArchive ? () => showArchive(category, code) : undefined,
    canApprove ? () => onToggleApproved(category, code) : undefined,
  );

  if (disabled) { context.onClick = undefined; }

  return (
    <WarningPopup disabled={!isCurrentUser}>
      <Label
        className={clsx(`aridhia-user-status-${context.className}`)}
        as={context.onClick ? 'a' : undefined}
        onClick={context.onClick}
        title={isCurrentUser ? intl.formatMessage({ id: context.tooltip }) : undefined}
      >
        <Icon name={context.icon} className="white" />
        <FormattedMessage id={context.message} />
      </Label>
    </WarningPopup>
  );
};

const mapStateToProps = ({
  auth: { users, role: { permissions: { users: { approve, destroy } } }, currentUser: { id } },
}, { category, code }) => {
  const user = findResult(users, category, code) || { approved: false, ...updateStates, id: code };

  return ({
    canApprove: approve,
    canArchive: destroy,
    disabled: user.updateStatus === states.PENDING,
    isCurrentUser: user.id === id,
    user,
  });
};

const mapDispatchToProps = {
  onToggleApproved: toggleUserApproved,
  showArchive: showArchiveUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserStatus);
